import { Box, Text, theme } from "@pallet-hq/hegel"
import Image from "components/Image"
import { MiniCompanyProfile_company } from "__generated__/MiniCompanyProfile_company"

const HeaderSection = ({
    company,
}: {
    company: MiniCompanyProfile_company
}) => {
    return (
        <Box display="flex" flexDirection="column">
            <Box>
                <Image
                    width={48}
                    height={48}
                    src={company.imageFile?.source}
                    colorSlug=""
                    alt={`${company.name}'s Logo`}
                    borderRadius="100%"
                    border={`1px solid ${theme.colors.gray300}`}
                    css={{ objectFit: "cover" }}
                    imgixParams={{
                        fit: "fill",
                        fill: "solid",
                        "fill-color": "white",
                    }}
                />
            </Box>
            <Text variant="headlineMedium" mt="12px">
                {company.name}
            </Text>
            <Text variant="paragraphMedium" color="gray800">
                {company.tagline}
            </Text>
        </Box>
    )
}

export { HeaderSection }
